import { useEffect, useState } from "react";

export default function ScoreGauge({ score = 0, label = "" }) {
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    const start = performance.now();
    const dur = 1400;
    const animate = (ts) => {
      const p = Math.min(1, (ts - start) / dur);
      const eased = 1 - Math.pow(1 - p, 3);
      setProgress(score * eased);
      if (p < 1) requestAnimationFrame(animate);
    };
    requestAnimationFrame(animate);
  }, [score]);

  const color = score >= 75 ? "#34C759" : score >= 50 ? "#EA580C" : "#DC2626";
  const radius = 92;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (progress / 100) * circumference;

  return (
    <div className="flex flex-col items-center" data-testid="score-gauge">
      <div className="relative w-[220px] h-[220px]">
        <svg viewBox="0 0 220 220" className="transform -rotate-90 w-full h-full">
          <circle
            cx="110"
            cy="110"
            r={radius}
            stroke="#E2E8F0"
            strokeWidth="12"
            fill="none"
          />
          <circle
            cx="110"
            cy="110"
            r={radius}
            stroke={color}
            strokeWidth="12"
            strokeLinecap="round"
            fill="none"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            style={{ transition: "stroke 600ms ease" }}
          />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <span className="font-mono text-[58px] font-semibold leading-none" style={{ color }}>
            {Math.round(progress)}
          </span>
          <span className="text-oc-textSecondary text-[13px] uppercase tracking-[0.08em] mt-1">
            van 100
          </span>
        </div>
      </div>
      {label ? (
        <p className="mt-5 text-oc-primary font-display font-semibold text-lg text-center max-w-xs">
          {label}
        </p>
      ) : null}
    </div>
  );
}
